var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.12305 2.24512V4.19383C8.12305 4.45774 8.22818 4.71136 8.41568 4.89832C8.60366 5.08548 8.85815 5.19051 9.12342 5.19041H11.3588",
    stroke: "black",
    strokeWidth: 0.591176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4093 5.39606V10.0392C11.3986 10.3429 11.3278 10.6414 11.2011 10.9177C11.0745 11.1939 10.8944 11.4423 10.6712 11.6486C10.4479 11.8559 10.186 12.0171 9.90032 12.1232C9.61468 12.2292 9.31094 12.2778 9.00648 12.2664H4.89337C4.58705 12.2804 4.28098 12.2338 3.9927 12.1293C3.70442 12.0248 3.43961 11.8644 3.21344 11.6573C2.98815 11.4504 2.80622 11.2009 2.67821 10.9231C2.5502 10.6453 2.47867 10.3448 2.46777 10.0392V4.47156C2.47853 4.16786 2.54929 3.86929 2.67596 3.59306C2.80264 3.31683 2.98273 3.0684 3.20586 2.86208C3.42917 2.65481 3.69113 2.49357 3.97677 2.38757C4.26242 2.28157 4.56615 2.23289 4.87061 2.2443H7.96709C8.43979 2.24263 8.89608 2.41753 9.24655 2.73473L10.8506 4.20982C11.0218 4.35726 11.16 4.53908 11.2562 4.74346C11.3525 4.94784 11.4047 5.1702 11.4093 5.39606Z",
    stroke: "black",
    strokeWidth: 0.591176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.93848 6.44238V10.1133",
    stroke: "black",
    strokeWidth: 0.591176,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.62222 7.98738L7.17802 6.54318C7.14677 6.51156 7.10956 6.48645 7.06853 6.46932C7.02751 6.45218 6.9835 6.44336 6.93904 6.44336C6.89458 6.44336 6.85056 6.45218 6.80954 6.46932C6.76852 6.48645 6.7313 6.51156 6.70005 6.54318L5.25586 7.98792",
    stroke: "black",
    strokeWidth: 0.591176,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/UploadIcon.e34d0395e833ad37f7659147e516e11e.svg";
export { ForwardRef as ReactComponent };